// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__l1zTF","error":"styles_error__69Ua9"};